module.exports = __webpack_public_path__ + "img/edit_icon.64819dcb.svg";